module.exports = __webpack_public_path__ + "img/feature.d10b03e9.png";